/*
 * File Created: Wednesday, 7th December 2022 10:55:21 am
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2022 Addble Solutions Private Limited. All Rights Reserved.
 */

import { createTheme } from '@mui/material';

export const theme = createTheme({
  typography: {
    fontFamily: ['Poppins', 'sans-serif'].join(','),
    body1: {
      fontSize: '0.875rem',
    },
    h6: {
      fontSize: '1rem',
    },
    h5: {
      fontSize: '1.625rem',
    },
  },
  // breakpoints: {
  //   values: {
  //     xs: 0,
  //     sm: 576,
  //     md: 768,
  //     lg: 992,
  //     xl: 1200,
  //   }
  // }
});
